import { render } from "./AutomationWizardFieldDate.vue?vue&type=template&id=671990e0&scoped=true"
import script from "./AutomationWizardFieldDate.vue?vue&type=script&lang=js"
export * from "./AutomationWizardFieldDate.vue?vue&type=script&lang=js"

import "./AutomationWizardFieldDate.vue?vue&type=style&index=0&id=671990e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671990e0"]])

export default __exports__